var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('router-link',{staticClass:"username-highlight",attrs:{"to":{ name: 'Profile', params: { id: _vm.notif.user_from.idt_user } }}},[_vm._v(" @"+_vm._s(_vm.notif.user_from.username)+" ")]),_vm._v(" "+_vm._s(_vm.$t('notif.published_new_post'))+" "),_c('div',{staticClass:"time"},[_vm._v(" "+_vm._s(_vm.notif.time)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }